import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, IconButton } from '@mui/material';
import { Icon } from '@iconify/react';
import { useToast } from './ui/ToastProvider';
interface BulkUploadListsModalProps {
  open: boolean;
  onClose: () => void;
  batch: {
    fileId: string;
    batchId: string;
    fileName: string;
    dataRows: number;
  };
}
interface RecordData {
  id: number;
  fullName: string;
  username: string;
  email: string;
  mobile: string;
  currency: string;
  branchCode: string;
  settlementAccount: string;
  designation: string;
  status: 'valid' | 'invalid' | 'duplicate';
  errorReason?: string;
}
const MOCK_NEW_RECORDS: RecordData[] = [{
  id: 1,
  fullName: 'Kwame Asante',
  username: 'kwame.asante',
  email: 'kwame.asante@ecobank.com',
  mobile: '+233 24 123 4567',
  currency: 'USD',
  branchCode: 'GH-ACC-001',
  settlementAccount: 'ACC-10001',
  designation: 'Manager',
  status: 'valid'
}, {
  id: 2,
  fullName: 'Fatoumata Ndiaye',
  username: 'fatoumata.ndiaye',
  email: 'fatoumata.ndiaye@ecobank.com',
  mobile: '+221 77 234 5678',
  currency: 'USD',
  branchCode: 'SN-DKR-001',
  settlementAccount: 'ACC-10002',
  designation: 'Officer',
  status: 'valid'
}];
const MOCK_INVALID_RECORDS: RecordData[] = [{
  id: 3,
  fullName: 'Ali',
  username: 'ali.ahmed',
  email: 'invalid-email',
  mobile: '030012345',
  currency: 'USD',
  branchCode: 'NG-LAG-001',
  settlementAccount: 'ACC-10003',
  designation: 'Clerk',
  status: 'invalid',
  errorReason: 'Invalid email format, Mobile number must be in international format'
}];
const MOCK_DUPLICATE_RECORDS: RecordData[] = [{
  id: 4,
  fullName: 'Grace Kipchoge',
  username: 'grace.kipchoge',
  email: 'grace.kipchoge@ecobank.com',
  mobile: '+254 72 111 1111',
  currency: 'USD',
  branchCode: 'KE-NBI-001',
  settlementAccount: 'ACC-10004',
  designation: 'Manager',
  status: 'duplicate',
  errorReason: 'Username already exists'
}];
const BulkUploadListsModal: React.FC<BulkUploadListsModalProps> = ({
  open,
  onClose,
  batch
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const {
    showToast
  } = useToast();
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
  const handleGetCheckApproval = () => {
    // Store new records in localStorage for checker inbox
    const recordsForApproval = MOCK_NEW_RECORDS.map(record => ({
      ...record,
      batchId: batch.batchId,
      fileName: batch.fileName,
      submittedAt: new Date().toISOString(),
      approvalStatus: 'pending'
    }));
    // Add to checker inbox
    const existingCheckerRecords = JSON.parse(localStorage.getItem('checkerInboxRecords') || '[]');
    localStorage.setItem('checkerInboxRecords', JSON.stringify([...existingCheckerRecords, ...recordsForApproval]));
    // Also add to maker inbox so maker can track all records
    const existingMakerRecords = JSON.parse(localStorage.getItem('makerInboxRecords') || '[]');
    localStorage.setItem('makerInboxRecords', JSON.stringify([...existingMakerRecords, ...recordsForApproval]));
    showToast('Records sent to Checker Inbox for approval', 'success', 'Approval Requested');
    onClose();
  };
  const renderRecordTable = (records: RecordData[], showActions: boolean = false) => <TableContainer data-id="element-297">
      <Table size="medium" data-id="element-298">
        <TableHead data-id="element-299">
          <TableRow data-id="element-300">
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-301">
              Full Name
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-302">
              Username
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-303">
              Email
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-304">
              Mobile
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-305">
              Currency
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-306">
              Branch Code
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-307">
              Settlement Account
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-308">
              Designation
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-309">
              Status
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody data-id="element-310">
          {records.map(record => <TableRow key={record.id} hover data-id="element-311">
              <TableCell data-id="element-312">{record.fullName}</TableCell>
              <TableCell data-id="element-313">{record.username}</TableCell>
              <TableCell data-id="element-314">{record.email}</TableCell>
              <TableCell data-id="element-315">{record.mobile}</TableCell>
              <TableCell data-id="element-316">{record.currency}</TableCell>
              <TableCell data-id="element-317">
                <Chip label={record.branchCode} size="small" sx={{
              backgroundColor: 'rgba(6, 182, 212, 0.1)',
              color: '#06B6D4',
              fontWeight: 600
            }} data-id="element-318" />
              </TableCell>
              <TableCell data-id="element-319">{record.settlementAccount}</TableCell>
              <TableCell data-id="element-320">{record.designation}</TableCell>
              <TableCell data-id="element-321">
                {record.status === 'valid' && <Chip label="Valid" size="small" sx={{
              backgroundColor: 'rgba(16, 185, 129, 0.1)',
              color: '#10B981'
            }} data-id="element-322" />}
                {record.status === 'invalid' && <Chip label="Invalid" size="small" sx={{
              backgroundColor: 'rgba(239, 68, 68, 0.1)',
              color: '#EF4444'
            }} data-id="element-323" />}
                {record.status === 'duplicate' && <Chip label="Duplicate" size="small" sx={{
              backgroundColor: 'rgba(245, 158, 11, 0.1)',
              color: '#F59E0B'
            }} data-id="element-324" />}
              </TableCell>
            </TableRow>)}
          {records.length === 0 && <TableRow data-id="element-325">
              <TableCell colSpan={9} align="center" sx={{
            py: 3
          }} data-id="element-326">
                No records found
              </TableCell>
            </TableRow>}
        </TableBody>
      </Table>
    </TableContainer>;
  return <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth PaperProps={{
    sx: {
      borderRadius: 2
    }
  }} data-id="element-327">
      <DialogTitle sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      pb: 2
    }} data-id="element-328">
        <Box data-id="element-329">
          <Typography variant="h6" fontWeight={600} data-id="element-330">
            Bulk Upload List
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{
          mt: 0.5
        }} data-id="element-331">
            {batch.fileName} • {batch.dataRows} rows
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small" data-id="element-332">
          <Icon icon="lucide:x" width={20} height={20} data-id="element-333" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{
      p: 0
    }} data-id="element-334">
        <Box sx={{
        borderBottom: 1,
        borderColor: 'divider'
      }} data-id="element-335">
          <Tabs value={activeTab} onChange={handleTabChange} sx={{
          px: 3
        }} data-id="element-336">
            <Tab label={<Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }} data-id="element-338">
                  <Typography variant="body2" fontWeight={500} data-id="element-339">
                    New Records
                  </Typography>
                  <Chip label={MOCK_NEW_RECORDS.length} size="small" sx={{
              height: 20,
              fontSize: '0.7rem',
              backgroundColor: 'rgba(16, 185, 129, 0.1)',
              color: '#10B981'
            }} data-id="element-340" />
                </Box>} data-id="element-337" />
            <Tab label={<Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }} data-id="element-342">
                  <Typography variant="body2" fontWeight={500} data-id="element-343">
                    Invalid Records
                  </Typography>
                  <Chip label={MOCK_INVALID_RECORDS.length} size="small" sx={{
              height: 20,
              fontSize: '0.7rem',
              backgroundColor: 'rgba(239, 68, 68, 0.1)',
              color: '#EF4444'
            }} data-id="element-344" />
                </Box>} data-id="element-341" />
            <Tab label={<Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }} data-id="element-346">
                  <Typography variant="body2" fontWeight={500} data-id="element-347">
                    Duplicate Records
                  </Typography>
                  <Chip label={MOCK_DUPLICATE_RECORDS.length} size="small" sx={{
              height: 20,
              fontSize: '0.7rem',
              backgroundColor: 'rgba(245, 158, 11, 0.1)',
              color: '#F59E0B'
            }} data-id="element-348" />
                </Box>} data-id="element-345" />
          </Tabs>
        </Box>
        <Box sx={{
        p: 3
      }} data-id="element-349">
          {activeTab === 0 && renderRecordTable(MOCK_NEW_RECORDS, true)}
          {activeTab === 1 && renderRecordTable(MOCK_INVALID_RECORDS)}
          {activeTab === 2 && renderRecordTable(MOCK_DUPLICATE_RECORDS)}
        </Box>
      </DialogContent>
      <DialogActions sx={{
      p: 3,
      pt: 2
    }} data-id="element-350">
        <Button variant="outlined" onClick={onClose} data-id="element-351">
          Close
        </Button>
        {activeTab === 0 && <Button variant="contained" onClick={handleGetCheckApproval} data-id="element-352">
            Get Check Approval
          </Button>}
      </DialogActions>
    </Dialog>;
};
export default BulkUploadListsModal;